import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RegionCode } from '@enums/region-country-codes.enums';
import { RoleType } from '@enums/role-type.enums';
import { DomainRole } from '@services/genesys-cloud-user.interface';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.scss'],
  imports: [NgTemplateOutlet],
})
export class EventsListComponent {
  @Input() role: DomainRole;
  @Input() region: RegionCode;
  @Output() readonly linkClick = new EventEmitter<boolean>();

  /**
   * Domain Role Type Enum
   * @returns {typeof RoleType}
   */
  public get roleType(): typeof RoleType {
    return RoleType;
  }

  /**
   * Region Country Codes Enum
   * @returns {typeof RegionCode}
   */
  public get regionCode(): typeof RegionCode {
    return RegionCode;
  }

  /**
   * Emit link click event to parent
   */
  onLinkClick(): void {
    console.log('Events Link clicked');
    this.linkClick.emit(true);
  }
}
